// components
import ReportGenerationTenant from "components/organisms/ReportGenerationTenant/ReportGenerationTenant";
import ReportGenerationAdmin from "components/organisms/ReportGenerationAdmin/ReportGenerationAdmin";

import { useAppSelector } from "app/hooks/hooks";
import { getLoggedInUserInfo } from "redux/userList/userSlice";
import { Users } from "redux/types";

const ReportGenerationPage = () => {
	const userInfo: Users["user"] = useAppSelector(getLoggedInUserInfo);
	const { tenant_code, outlets } = userInfo?.data?.[0] ?? { tenant_code: "", outlets: [] };
	return <div>{tenant_code ? <ReportGenerationTenant outlets={outlets} /> : <ReportGenerationAdmin />}</div>;
};

export default ReportGenerationPage;
